import { useTheme } from '@mui/material';

export const useDocumentLineGridSx = () => {
  const theme = useTheme();
  const ui = theme.palette.ui;

  return {
    '& .docline-pinned-row .MuiDataGrid-cell': {
      backgroundColor: `${ui.tableHeader} !important`,
      fontWeight: '600',
      py: 1,
      minHeight: 38,
      display: 'flex',
      alignItems: 'center',
    },
    '& .docline-pinned-row:hover .MuiDataGrid-cell': {
      backgroundColor: `${ui.tableHeader} !important`,
    },
  };
};
